import Constants from '../Constants';
import { getHostName } from './getHostName';
import { getExperience } from './getExperience';
import { getLanguage } from './getLanguage';
import { getLanguageFromLocale } from './getLanguageFromLocale';

export const getSiteCoreQuery = (path: string, getChildren: boolean, locale?: string, getOnlySubQueryPath?: boolean): string => {
  const sitecoreHostName = getHostName();
  const experience = getExperience();
  let language = getLanguageFromLocale(locale);
  if (!language) language = getLanguage();
  const subQuery = getOnlySubQueryPath ? `('${path}')` : `('/sitecore/content/Extranet/${experience}/home/${path}')`;
  const selectChildren = getChildren === true ? '/Children' : '';
  return `${sitecoreHostName}/sitecore/api/ssc/aggregate/content/Items${subQuery}${selectChildren}?language=${language}&sc_apikey=${Constants.apiKeyOData}&$select=TemplateName,Created&$expand=Fields($select=Name,Value)`;
};
